import { render, staticRenderFns } from "./list-table-widget.vue?vue&type=template&id=0be9fa2e&scoped=true"
import script from "./list-table-widget.vue?vue&type=script&lang=js"
export * from "./list-table-widget.vue?vue&type=script&lang=js"
import style0 from "./list-table-widget.vue?vue&type=style&index=0&id=0be9fa2e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be9fa2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0be9fa2e')) {
      api.createRecord('0be9fa2e', component.options)
    } else {
      api.reload('0be9fa2e', component.options)
    }
    module.hot.accept("./list-table-widget.vue?vue&type=template&id=0be9fa2e&scoped=true", function () {
      api.rerender('0be9fa2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/dashboard-design/charts/chart-widget/list-table-widget.vue"
export default component.exports